import { ifAuthenticated } from "@/router";

export default [
  {
    path: "/help-center/categories",
    name: "helpCenterCategories",
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "helpCenter" */ "@/views/help-center/categories/Categories.vue")
  },
  {
    path: "/help-center/categories/create",
    name: "helpCenterCategoryCreate",
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "helpCenter" */ "@/views/help-center/categories/CategoryCreate.vue")
  },
  {
    path: "/help-center/categories/:categoryId/edit",
    name: "helpCenterCategoryEdit",
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "helpCenter" */ "@/views/help-center/categories/CategoryEdit.vue")
  },
  {
    path: "/help-center/entries",
    name: "helpCenterEntries",
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "helpCenter" */ "@/views/help-center/entries/Entries.vue")
  },
  {
    path: "/help-center/entries/create",
    name: "helpCenterEntryCreate",
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "helpCenter" */ "@/views/help-center/entries/EntryCreate.vue")
  },
  {
    path: "/help-center/entries/:entryId/edit",
    name: "helpCenterEntryEdit",
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "helpCenter" */ "@/views/help-center/entries/EntryEdit.vue")
  }
];
